import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountCtaButtonWithFormKit() {
	const ctaButtonWithFormKits = [
		...document.querySelectorAll('[data-cta-button-formkit]'),
	];

	if (!ctaButtonWithFormKits.length) {
		console.warn('[CtaButtonWithFormKit] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	await Promise.all(
		Array.from(ctaButtonWithFormKits).map(async (item, index) => {
			const app = createApp({
				name: `CtaButtonWithFormKitApp-${index}`,
			});
			app.component(
				'cta-button-with-popup-form',
				defineAsyncComponent(
					() =>
						import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
				),
			);
			app.component(
				'form-kit-builder-container',
				defineAsyncComponent(
					() =>
						import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
				),
			);
			await initFormKitSchema(app, options);
			app.use(store);
			app.mount(item);
		}),
	);
}

mountCtaButtonWithFormKit().catch((error) => {
	console.error('Error mounting CtaButtonWithFormKit:', error);
});
